import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DivineServiceTypeClient,
  DivineServiceTypeDto,
  CreateDivineServiceTypeDto,
  UpdateDivineServiceTypeDto,
  UpdateDivineServiceTypeSortOrderDto,
} from '../generated/api-client';

@Injectable({ providedIn: 'root' })
export class DivineServiceTypeApiService {
  constructor(private readonly client: DivineServiceTypeClient) {}

  getAll(): Observable<DivineServiceTypeDto[]> {
    return this.client.getAll();
  }

  getById(id: number): Observable<DivineServiceTypeDto> {
    return this.client.getById(id);
  }

  create(dto: CreateDivineServiceTypeDto): Observable<DivineServiceTypeDto> {
    return this.client.create(dto);
  }

  update(id: number, dto: UpdateDivineServiceTypeDto): Observable<void> {
    return this.client.update(id, dto);
  }

  delete(id: number): Observable<void> {
    return this.client.delete(id);
  }

  updateSortOrder(dto: UpdateDivineServiceTypeSortOrderDto): Observable<void> {
    return this.client.updateSortOrder(dto);
  }
}
